module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"es":{"accept":"Aceptar"},"en":{"accept":"Accept"}}')
  delete Component.options._Ctor
}
